import { c as _c } from "react/compiler-runtime";
import { NumberInput as ChakraNumberInput } from '@chakra-ui/react';
import { forwardRef } from 'react';
export interface NumberInputProps extends ChakraNumberInput.RootProps {}
export const NumberInputRoot = forwardRef<HTMLDivElement, NumberInputProps>(function NumberInput(props, ref) {
  const $ = _c(8);
  let children;
  let rest;
  if ($[0] !== props) {
    ({
      children,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = rest;
  } else {
    children = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ChakraNumberInput.Control><ChakraNumberInput.IncrementTrigger /><ChakraNumberInput.DecrementTrigger /></ChakraNumberInput.Control>;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== children || $[5] !== ref || $[6] !== rest) {
    t1 = <ChakraNumberInput.Root ref={ref} variant="outline" {...rest}>{children}{t0}</ChakraNumberInput.Root>;
    $[4] = children;
    $[5] = ref;
    $[6] = rest;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
});
export const NumberInputField = ChakraNumberInput.Input;
export const NumberInputScruber = ChakraNumberInput.Scrubber;
export const NumberInputLabel = ChakraNumberInput.Label;